import AbortService from "@rmp/core/services/abortService";
import BaseOrganizationController from "@rmp/core/api/base/baseOrganizationController";

export class AppsController extends BaseOrganizationController {
	constructor(abortService: AbortService) {
		super(abortService);
	}

	getApps = this.api.apps.getApps;
}
